import { useAppState } from "../../context";
import { SimplePageType } from "../../types";
import { fetchJson } from "../../utils";

export const useSimplePage = () => {
    const [pageCache, setPageCache] = useAppState<Map<string, SimplePageType>>('simple-page-cache', new Map());

    const findPage = async (slug: string): Promise<SimplePageType | null> => {
        if (pageCache.has(slug)) {
            return pageCache.get(slug) || null;
        }

        let retryCount = 0;
        while (retryCount < 3) {
            try {
                const { json } = await fetchJson<SimplePageType>(`/api/pages/${slug}`);
                const newCache = new Map(pageCache);
                newCache.set(slug, json);
                setPageCache(newCache);
                return json;
            } catch (error) {
                console.error(`Retry ${retryCount + 1} failed:`, error);
            }
            retryCount++;
        }

        return null;
    };

    return { findPage };
}; 